/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';
import { CloseIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/integrity-portal';

type Props = {
  onDismiss: () => void;
};

const styles = {
  notificationContainer: css`
    padding: var(--cds-spacing-100) var(--cds-spacing-200);
    top: 0;
    z-index: 1000;
    position: absolute;
    gap: var(--cds-spacing-200);
    border-radius: 3px;
    background: var(--cds-color-neutral-primary, #1f1f1f);
    margin-top: var(--cds-spacing-200);
    left: 50%;
    transform: translate(-50%);
  `,
  notificationText: css`
    color: var(--cds-color-neutral-primary-invert, #fff);
    white-space: nowrap;
  `,
  closeButton: css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: var(--cds-spacing-100);
    padding: 0;
    border: none;
    width: 24px;
    height: 24px;
  `,
  closeIcon: css`
    vertical-align: middle;
    padding-bottom: var(--cds-spacing-50);
  `,
};

const VideoSkippingDisabledNotification: React.FC<Props> = ({ onDismiss }) => {
  return (
    <Grid css={styles.notificationContainer}>
      <Typography2 component="p" css={styles.notificationText}>
        {_t('Skipping forward is only available on video sections you have already watched.')}
        <button type="button" css={styles.closeButton} onClick={onDismiss}>
          <CloseIcon size="medium" css={styles.closeIcon} />
        </button>
      </Typography2>
    </Grid>
  );
};

export default VideoSkippingDisabledNotification;
